import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import { IconName } from '@fortawesome/pro-solid-svg-icons';

interface FolderTypeIconProps {
  state?: API_FOLDERDATAENTITY_STATE;
  folderAccess?: API_FOLDERDATAENTITY_FOLDERACCESS;
  symlinkDirectory?: boolean;
  symlinkDirectorySource?: boolean;
  linkId?: number;
}

const renderFolderStateIcon = (
  state: API_FOLDERDATAENTITY_STATE,
  symlinkDirectory: boolean,
  symlinkDirectorySource: boolean,
  linkId?: number
) => {
  let icon: IconName;
  let transform = "shrink-2 right-8 down-6";
  let className = "file-state-icon";
  if (state === "LOCKED") {
    icon = "lock-alt";
  } else if (symlinkDirectory || linkId) {
    icon = "link";
    if (linkId) {
      // for external links, use color of empty folder
      className = "emptyFolder";
    }
  } else if (symlinkDirectorySource) {
    icon = "bow-arrow";
    transform = "shrink-2 left-5 down-6";
  } else {
    return null;
  }
  return <FontAwesomeIcon fixedWidth={true} icon={["fas", icon]} className={className} transform={transform} />;
};

export const FolderTypeIcon = ({
  state,
  folderAccess,
  symlinkDirectory,
  symlinkDirectorySource,
  linkId,
}: FolderTypeIconProps) => (
  <span className="fa-layers fa-fw">
    <FontAwesomeIcon fixedWidth={true} size="lg" icon={["far", "folder"]} />
    {folderAccess && (
      <FontAwesomeIcon
        fixedWidth={true}
        icon={["fas", folderAccess === "DENIED" ? "lock" : "key"]}
        className="file-state-icon"
        transform="shrink-2 right-8 down-6"
      />
    )}
    {renderFolderStateIcon(state, symlinkDirectory, symlinkDirectorySource, linkId)}
  </span>
);
